import { Resource, BaseModel } from "@ngx-resource-toolkit/core";
import { SelectReducer, SelectEpics } from './select.store';
import { environment } from "../../../environments/environment";
import { LeaResource } from "./lea.resource";

@Resource({
    modes: {},
    store: {
        namespace: 'selectOptions',
        reducer: SelectReducer,
        epics: SelectEpics,
    }
})
export class SelectModel extends BaseModel {

    /**
     * This model is a resource model used for fetching
     * all select options across the application
     */

}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/resource/select.model.ts